import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { BaseComponent } from '../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { permissionAreaKeyNameOf, permissionEnityKeyNameOf } from '../../../helpers/permission.helpers';
import { BroadCastEvents } from '../../../common/broad-cast-events.enum';
import { AdminArea } from '../../../models/roles';
import { SecureBaseComponentContext } from '../../../modules/tcm-common/services/secure-base-component-context.service';
import { CompanyInfoWidgetViewModel } from '../../../models/companies/company-info-widget-view-model';
import { CompanyInfoWidgetRequest } from '../../../models/companies/company-info-widget-request';
import { UpdateCompanyLogoComponent } from './update-logo/update-company-logo.component';
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';

@Component({
    selector: 'company-info-widget',
    templateUrl: './company-info-widget.component.html',
    styleUrls: ['./company-info-widget.component.scss'],
    standalone: false
})
export class CompanyInfoWidgetComponent extends BaseComponent<CompanyInfoWidgetRequest, CompanyInfoWidgetViewModel> {

  private updateSubscription: Subscription;
  private permissionsSubscription: Subscription;
  public canUpdatePhoto = true;

  constructor(
    protected override componentContext: SecureBaseComponentContext, protected override route: ActivatedRoute) {

    super(componentContext, route);

    this.actionName = 'CompanyWidget/InfoWidget';

    this.updateSubscription = this.componentContext.broadcastService
      .getEvents(BroadCastEvents.CompanyLogoChanged, BroadCastEvents.CompanyChanged)
      .subscribe(e => {
        if (e.name == BroadCastEvents.CompanyLogoChanged) {
          this.viewModel.logo = e.args.src;
        } else {
          this.refresh();
        }
      });

    this.permissionsSubscription = this.componentContext.permissionService
      .getEntityPermissions$(permissionAreaKeyNameOf('admin'), permissionEnityKeyNameOf<AdminArea>('companies'))
      .subscribe(x => {
        this.canUpdatePhoto = x && x.canEdit === true;
      });
  }

  public openUplaodLogoModal($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.componentContext.modalService.openComponentInModal(UpdateCompanyLogoComponent, "sm", { requestModel: { companyId: this.requestModel.companyId } });
  }

  protected createRequestModel(): CompanyInfoWidgetRequest {
    return {} as CompanyInfoWidgetRequest;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.updateSubscription.unsubscribe();
    this.permissionsSubscription.unsubscribe();
  }
}
